/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import PlanManagement from 'components/Plans/PlanManagement';
import PlansTableCard from 'components/Plans/PlansTableCard';
import React, { useState, useEffect } from 'react';
import PlansTableCardStatic from 'components/Plans/PlansTableCardStatic';
// import CircularProgress from '@mui/material/CircularProgress';
import NoAPIManagement from 'components/Plans/NoAPIManagement';
import APIPlanManagement from 'components/Plans/APIPlanManagement';
import OverageFees from 'components/Plans/OverageFees';
import PlansSectionCard from 'components/Plans/PlansSectionCard';

interface IPlansOverviewProps {
  cur_user: any;
  team: any;
  handleTabChange: any;
}

const PlansOverview: React.FC<IPlansOverviewProps> = ({ handleTabChange, cur_user, team }) => {
  const [ activeBtn, setActiveBtn ] = useState('monthly');
  const [ cusObj, setCusObj ] = useState<any>({ isLoading: true, data: {} });
  const [ activePlan, setActivePlan ] = useState<any>({ isLoading: true, data: '' });
  const [ newPlan, setNewPlan ] = useState<any>('');
  const [ planState, setPlanState ] = useState<any>({
    isLoading: true,
    data: {
      quantity: 1,
      selectedPrice: { priceId: '', interval: '', amount: 0 },
    }
  });
  const [ currentPlan, setCurrentPlan ] = useState<any>({ isLoading: true, data: {} });
  const [ customerId, setCustomerId ] = useState<string>('');
  const [ subInfo, setSubInfo ] = useState({});
  const [ apiSubs, setApiSubs ] = useState({ isLoading: true, data: [] });
  const [ tableOpen, setTableOpen ] = useState<boolean>(true);

  const entMonthlyObj = {
    priceId: process.env.REACT_APP_BITE_ENT_MONTHLY!,
    interval: 'month',
    amount: 6400 / 100
  };
  const entAnnualObj = {
    priceId: process.env.REACT_APP_BITE_ENT_ANNUAL!,
    interval: 'year',
    amount: 70800 / 100
  };
  const proMonthlyObj = {
    priceId: process.env.REACT_APP_BITE_PRO_MONTHLY!,
    interval: 'month',
    amount: 4100 / 100
  };
  const proAnnualObj = {
    priceId: process.env.REACT_APP_BITE_PRO_ANNUAL!,
    interval: 'year',
    amount: 45600 / 100
  };
  const standardMonthlyObj = {
    priceId: process.env.REACT_APP_BITE_STANDARD_MONTHLY!,
    interval: 'month',
    amount: 2200 / 100
  };
  const standardAnnualObj = {
    priceId: process.env.REACT_APP_BITE_STANDARD_ANNUAL!,
    interval: 'year',
    amount: 22800 / 100
  };

  const handleScroll = () => {
    document.getElementById('overage-notice-container')?.scrollIntoView({ behavior: 'smooth' });
  };

  const getActivePlan = (teamPlan: any) => {
    if (teamPlan?.includes('none')) {
      setActivePlan({ isLoading: false, data: 'none' });
      setNewPlan('none');
    }
    if (teamPlan?.includes('standard')) {
      setActivePlan({ isLoading: false, data: 'Standard' });
      setNewPlan('Standard');
    }
    if (teamPlan?.includes('pro')) {
      setActivePlan({ isLoading: false, data: 'Pro' });
      setNewPlan('Pro');
    }
    if (teamPlan?.includes('enterprise')) {
      setActivePlan({ isLoading: false, data: 'Enterprise' });
      setNewPlan('Enterprise');
    }
  };

  const initializePlan = () => {
    setPlanState({
      isLoading: true,
      data: {
        quantity: 1,
        selectedPrice: { priceId: '', interval: '', amount: 0 },
      }
    });
    setCurrentPlan({ isLoading: true, data: {} });
    cur_user.stripe_cus_info.map((cus: any) => {
      if (cus.name === team.name) {
        setCusObj({ isLoading: false, data: cus });
        setCustomerId(cus.id);
        if (cus?.subscriptions?.data?.length === 0) {
          setPlanState({
            isLoading: false,
            data: {
              quantity: 1,
              selectedPrice: { priceId: '', interval: '', amount: 0 },
            }
          });
        } else {
          cus?.subscriptions?.data.map((sub: any) => {
            if (!sub.metadata.type || sub.metadata.type !== 'api') {
              setSubInfo(sub);
              sub.items.data.map((item: any) => {
                if (item?.metadata?.type === 'fixed' || item?.metadata?.type === 'trial') {
                  setPlanState({
                    isLoading: false,
                    data: {
                      quantity: item?.quantity ? item?.quantity : 1,
                      selectedPrice: {
                        priceId: item?.plan?.id,
                        interval: item?.plan?.interval,
                        amount: item?.plan?.amount / 100
                      }
                    }
                  });
                  setCurrentPlan({
                    isLoading: false,
                    data: {
                      quantity: item?.quantity ? item?.quantity : 1,
                      selectedPrice: {
                        priceId: item?.plan?.id,
                        interval: item?.plan?.interval,
                        amount: item?.plan?.amount / 100
                      }
                    }
                  });
                  if (item?.plan?.interval === 'year') {
                    setActiveBtn('annual');
                  } else {
                    setActiveBtn('monthly');
                  }
                }
              });
            }
          });
        }
      }
    });
  };

  const getApiSubs = () => {
    const subs: any = [];
    cur_user.stripe_cus_info.map((cus: any) => {
      if (cus.name === team.name) {
        cus?.subscriptions?.data?.map((sub: any) => {
          if (sub.metadata.type || sub.metadata.type === 'api') {
            subs.push(sub);
          }
        });
      }
      setApiSubs({ isLoading: false, data: subs });
    });
  };

  useEffect(() => {
    initializePlan();
    getActivePlan(team?.attributes?.tier);
    getApiSubs();
  }, [ team ]);

  const handleActiveBtnChange = (type: string) => {
    if (type === 'monthly') {
      setActiveBtn('monthly');
      if (newPlan === 'Standard') {
        setPlanState({
          ...planState,
          data: {
            ...planState.data,
            selectedPrice: standardMonthlyObj
          }
        });
      }
      if (newPlan === 'Pro') {
        setPlanState({
          ...planState,
          data: {
            ...planState.data,
            selectedPrice: proMonthlyObj
          }
        });
      }
      if (newPlan === 'Enterprise') {
        setPlanState({
          ...planState,
          data: {
            ...planState.data,
            selectedPrice: entMonthlyObj
          }
        });
      }
    }
    if (type === 'annual') {
      setActiveBtn('annual');
      if (newPlan === 'Standard') {
        setPlanState({
          ...planState,
          data: {
            ...planState.data,
            selectedPrice: standardAnnualObj
          }
        });
      }
      if (newPlan === 'Pro') {
        setPlanState({
          ...planState,
          data: {
            ...planState.data,
            selectedPrice: proAnnualObj
          }
        });
      }
      if (newPlan === 'Enterprise') {
        setPlanState({
          ...planState,
          data: {
            ...planState.data,
            selectedPrice: entAnnualObj
          }
        });
      }
    }
  };

  return (
    <div className='plans-container'>
      <div className='account-plan-container'>
        <div className='plans-header'>
          <div className='plans-header-content'>
            <div className='plans-header-text-group'>
              <div className='plans-header-primary-text'>
                Account Plans
              </div>
            </div>
            <div className='plans-options-container'>
              <div className={`plans-cycles-btn${activeBtn === 'annual' ? '-selected' : ''}`} onClick={() => handleActiveBtnChange('annual')}>
                <div className={`plans-cycles-btn-text${activeBtn === 'annual' ? '-selected' : ''}`}>
                  Annual
                </div>
              </div>
              <div className={`plans-cycles-btn${activeBtn === 'monthly' ? '-selected' : ''}`} onClick={() => handleActiveBtnChange('monthly')}>
                <div className={`plans-cycles-btn-text${activeBtn === 'monthly' ? '-selected' : ''}`}>
                  Monthly
                </div>
              </div>
            </div>
          </div>
        </div>
        {team.attributes?.team_admin?.includes(cur_user.basics?.email) ? (
          <div className='plans-table-content'>
            <PlansSectionCard handleScroll={handleScroll} handleTabChange={handleTabChange} />
            <PlansTableCard
              currentPlan={currentPlan}
              subInfo={subInfo}
              setCurrentPlan={setCurrentPlan}
              type='Standard'
              cusId={customerId}
              cusObj={cusObj}
              quantity={planState.data.quantity}
              cur_user={cur_user}
              team={team}
              activeBtn={activeBtn}
              activePlan={activePlan}
              setNewPlan={setNewPlan}
              planState={planState}
              proAnnualObj={proAnnualObj}
              proMonthlyObj={proMonthlyObj}
              standardAnnualObj={standardAnnualObj}
              standardMonthlyObj={standardMonthlyObj}
              entAnnualObj={entAnnualObj}
              entMonthlyObj={entMonthlyObj}
              setPlanState={setPlanState}
              newPlan={newPlan}
              monthlyPrice='$22'
              annualPrice='$19'
              icon={
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M12.3578 7.17846C12.2266 7.11287 12.161 7.08008 12.0922 7.06717C12.0313 7.05574 11.9687 7.05574 11.9078 7.06717C11.839 7.08008 11.7734 7.11287 11.6422 7.17846L2 11.9996L11.6422 16.8207C11.7734 16.8863 11.839 16.9191 11.9078 16.932C11.9687 16.9434 12.0313 16.9434 12.0922 16.932C12.161 16.9191 12.2266 16.8863 12.3578 16.8207L22 11.9996L12.3578 7.17846Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              }
            />
            <PlansTableCard
              currentPlan={currentPlan}
              subInfo={subInfo}
              setCurrentPlan={setCurrentPlan}
              type='Pro'
              cusId={customerId}
              cusObj={cusObj}
              quantity={planState.data.quantity}
              cur_user={cur_user}
              team={team}
              activeBtn={activeBtn}
              planState={planState}
              proAnnualObj={proAnnualObj}
              proMonthlyObj={proMonthlyObj}
              standardAnnualObj={standardAnnualObj}
              standardMonthlyObj={standardMonthlyObj}
              entAnnualObj={entAnnualObj}
              entMonthlyObj={entMonthlyObj}
              setNewPlan={setNewPlan}
              setPlanState={setPlanState}
              newPlan={newPlan}
              activePlan={activePlan}
              monthlyPrice='$41'
              annualPrice='$39'
              icon={
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M7 11.9996L2 14.4996L11.6422 19.3207C11.7734 19.3863 11.839 19.4191 11.9078 19.432C11.9687 19.4434 12.0313 19.4434 12.0922 19.432C12.161 19.4191 12.2266 19.3863 12.3578 19.3207L22 14.4996L17 11.9996M2 9.49958L11.6422 4.67846C11.7734 4.61287 11.839 4.58008 11.9078 4.56717C11.9687 4.55574 12.0313 4.55574 12.0922 4.56717C12.161 4.58008 12.2266 4.61287 12.3578 4.67846L22 9.49958L12.3578 14.3207C12.2266 14.3863 12.161 14.4191 12.0922 14.432C12.0313 14.4434 11.9687 14.4434 11.9078 14.432C11.839 14.4191 11.7734 14.3863 11.6422 14.3207L2 9.49958Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              }
            />
            <PlansTableCard
              currentPlan={currentPlan}
              subInfo={subInfo}
              setCurrentPlan={setCurrentPlan}
              type='Enterprise'
              cusId={customerId}
              cusObj={cusObj}
              cur_user={cur_user}
              setPlanState={setPlanState}
              quantity={planState.data.quantity}
              team={team}
              activeBtn={activeBtn}
              newPlan={newPlan}
              planState={planState}
              proAnnualObj={proAnnualObj}
              proMonthlyObj={proMonthlyObj}
              standardAnnualObj={standardAnnualObj}
              standardMonthlyObj={standardMonthlyObj}
              entAnnualObj={entAnnualObj}
              entMonthlyObj={entMonthlyObj}
              setNewPlan={setNewPlan}
              activePlan={activePlan}
              monthlyPrice='$64'
              annualPrice='$59'
              icon={
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M2 11.9996L11.6422 16.8207C11.7734 16.8863 11.839 16.9191 11.9078 16.932C11.9687 16.9434 12.0313 16.9434 12.0922 16.932C12.161 16.9191 12.2266 16.8863 12.3578 16.8207L22 11.9996M2 16.9996L11.6422 21.8207C11.7734 21.8863 11.839 21.9191 11.9078 21.932C11.9687 21.9434 12.0313 21.9434 12.0922 21.932C12.161 21.9191 12.2266 21.8863 12.3578 21.8207L22 16.9996M2 6.99958L11.6422 2.17846C11.7734 2.11287 11.839 2.08008 11.9078 2.06717C11.9687 2.05574 12.0313 2.05574 12.0922 2.06717C12.161 2.08008 12.2266 2.11287 12.3578 2.17846L22 6.99958L12.3578 11.8207C12.2266 11.8863 12.161 11.9191 12.0922 11.932C12.0313 11.9434 11.9687 11.9434 11.9078 11.932C11.839 11.9191 11.7734 11.8863 11.6422 11.8207L2 6.99958Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              }
            />
          </div>
        ) : (
          <div className='plans-table-content'>
            <PlansTableCardStatic
              type='Standard'
              activeBtn={activeBtn}
              monthlyPrice='$22'
              annualPrice='$19'
              icon={
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M12.3578 7.17846C12.2266 7.11287 12.161 7.08008 12.0922 7.06717C12.0313 7.05574 11.9687 7.05574 11.9078 7.06717C11.839 7.08008 11.7734 7.11287 11.6422 7.17846L2 11.9996L11.6422 16.8207C11.7734 16.8863 11.839 16.9191 11.9078 16.932C11.9687 16.9434 12.0313 16.9434 12.0922 16.932C12.161 16.9191 12.2266 16.8863 12.3578 16.8207L22 11.9996L12.3578 7.17846Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              }
            />
            <PlansTableCardStatic
              type='Pro'
              activeBtn={activeBtn}
              monthlyPrice='$41'
              annualPrice='$39'
              icon={
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M7 11.9996L2 14.4996L11.6422 19.3207C11.7734 19.3863 11.839 19.4191 11.9078 19.432C11.9687 19.4434 12.0313 19.4434 12.0922 19.432C12.161 19.4191 12.2266 19.3863 12.3578 19.3207L22 14.4996L17 11.9996M2 9.49958L11.6422 4.67846C11.7734 4.61287 11.839 4.58008 11.9078 4.56717C11.9687 4.55574 12.0313 4.55574 12.0922 4.56717C12.161 4.58008 12.2266 4.61287 12.3578 4.67846L22 9.49958L12.3578 14.3207C12.2266 14.3863 12.161 14.4191 12.0922 14.432C12.0313 14.4434 11.9687 14.4434 11.9078 14.432C11.839 14.4191 11.7734 14.3863 11.6422 14.3207L2 9.49958Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              }
            />
            <PlansTableCardStatic
              type='Enterprise'
              activeBtn={activeBtn}
              monthlyPrice='$64'
              annualPrice='$59'
              icon={
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M2 11.9996L11.6422 16.8207C11.7734 16.8863 11.839 16.9191 11.9078 16.932C11.9687 16.9434 12.0313 16.9434 12.0922 16.932C12.161 16.9191 12.2266 16.8863 12.3578 16.8207L22 11.9996M2 16.9996L11.6422 21.8207C11.7734 21.8863 11.839 21.9191 11.9078 21.932C11.9687 21.9434 12.0313 21.9434 12.0922 21.932C12.161 21.9191 12.2266 21.8863 12.3578 21.8207L22 16.9996M2 6.99958L11.6422 2.17846C11.7734 2.11287 11.839 2.08008 11.9078 2.06717C11.9687 2.05574 12.0313 2.05574 12.0922 2.06717C12.161 2.08008 12.2266 2.11287 12.3578 2.17846L22 6.99958L12.3578 11.8207C12.2266 11.8863 12.161 11.9191 12.0922 11.932C12.0313 11.9434 11.9687 11.9434 11.9078 11.932C11.839 11.9191 11.7734 11.8863 11.6422 11.8207L2 6.99958Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              }
            />
          </div>
        )}
        {!planState?.isLoading &&
        team.attributes?.team_admin?.includes(cur_user.basics?.email) && (
          <PlanManagement
            newPlan={newPlan}
            planState={planState}
            team={team}
            cusId={customerId}
            cusObj={cusObj}
            currentPlan={currentPlan}
            setCurrentPlan={setCurrentPlan}
            cur_user={cur_user}
            activeBtn={activeBtn}
            quantity={planState.data.quantity}
            subInfo={subInfo}
            handleTabChange={handleTabChange}
          />
        )}
      </div>
      <OverageFees tableOpen={tableOpen} setTableOpen={setTableOpen} />
      {!cur_user.selected_team.attributes.tier.includes('enterprise') &&
        apiSubs.data.length === 0 ? (
          <NoAPIManagement />
        ) : (
          <APIPlanManagement handleTabChange={handleTabChange} apiSubs={apiSubs} cusId={customerId} cur_user={cur_user} />
        )
      }
    </div>
  );
};

export default PlansOverview;
